import React, { useEffect, useState } from "react";
import { Card, Tooltip } from "antd";
import GaugeComponent from "react-gauge-component";
import { InfoCircleFilled } from "@ant-design/icons";
import "../../../../App.css";
import { useDispatch, useSelector } from "react-redux";
import {
  apiCallStatus,
  fetchAssetHealthWeightage,
} from "../actions/maintenanceDashboardService";
import {
  assetHealthArc,
  assetHealthPointer,
  assetHealthStyle,
  assetHealthStatusData,
  renderStatusData,
} from "../constant/maintenanceConstantData";
import { AssetHealthComponent } from "../maintenanceCommonComponent";

export default function AssetHealthCard() {
  const dispatch = useDispatch();
  const [assetScore, setAssetScore] = useState(0);

  const [scores, setScores] = useState({
    tpvScore: "",
    incidentScore: "",
    preventiveMaintenceScore: "",
    maintenanceWorkRequestScore: "",
    assetHealthWeights:"",
  });
  const maintenanceDashboardList = useSelector((state) => state?.maintenanceDashboardList);
  useEffect(() => {
    if (maintenanceDashboardList) {
      setScores({
        tpvScore: maintenanceDashboardList?.tpvScore,
        incidentScore: maintenanceDashboardList?.incidentScore,
        preventiveMaintenceScore: maintenanceDashboardList?.preventiveMaintenceScore,
        maintenanceWorkRequestScore: maintenanceDashboardList?.maintenanceWorkRequestScore,
        assetHealthWeights: maintenanceDashboardList?.weights,
      });
    }
  }, [maintenanceDashboardList]);

  // const {
  //   tpvScore,
  //   incidentScore,
  //   preventiveMaintenceScore,
  //   maintenanceWorkRequestScore,
  //   weights: assetHealthWeights,
  // } = useSelector((state) => state?.maintenanceDashboardList);

  useEffect(() => {
    dispatch(fetchAssetHealthWeightage());
  }, []);
  useEffect(() => {
    const calculateValue = () => {
      const value = (
        (scores?.assetHealthWeights?.PreventiveWeight *
          (
            scores?.preventiveMaintenceScore?.slice(0, -1)
            ) +
          scores?.assetHealthWeights?.TpvWeight *
            (scores?.tpvScore?.slice(0, -1)) +
          scores?.assetHealthWeights?.WorkRequestWeight *
            (
            scores?.maintenanceWorkRequestScore?.slice(0, -1)
              ) +
          scores?.assetHealthWeights?.IncidentWeight *
            ( scores?.incidentScore?.slice(0, -1) )) /
        100
      ).toFixed(2);
      setAssetScore(value);
    };
    if (
      scores?.assetHealthWeights &&
      scores?.preventiveMaintenceScore &&
      scores?.tpvScore &&
      scores?.maintenanceWorkRequestScore &&
      scores?.incidentScore
    )
      calculateValue();
  }, [
    scores?.assetHealthWeights,
    scores?.preventiveMaintenceScore,
    scores?.tpvScore,
    scores?.maintenanceWorkRequestScore,
    scores?.incidentScore,
  ]);
  useEffect(() => {
    dispatch(apiCallStatus({ assetScore }));
  }, [assetScore]);
  const assetHealthInfo = (
    <div className="asset-health-tooltip">
      <div>
        <span>Work Request Status:</span>
        <span>High Priority Work Completion Status</span>
      </div>

      <div>
        <span>Preventive Maintenance:</span>
        <span>Last Quarterly Realised</span>
      </div>

      <div>
        <span>Work Request Status:</span>
        <span>Sum of High and Medium Points</span>
      </div>
    </div>
  );
  return (
    <Card className="first-card-class">
      <div className="card-main-div">
        <div className="card-first-div">
          <h3 className="card-heading">Asset Health Alert Score</h3>
          <div className="chart-main-div">
            <div className="gauge-component-class">
              <GaugeComponent
                value={assetScore}
                type="radial"
                arc={assetHealthArc}
                pointer={assetHealthPointer}
                style={assetHealthStyle}
              />
            </div>

            <div className="chart-asset-health-score">
              <p className="para-asset-health-score">Asset Health Score</p>
              <Tooltip
                title={assetHealthInfo}
                placement="right"
                overlayClassName="asset-health-card-tooltip-overlay"
              >
                <InfoCircleFilled />
              </Tooltip>
            </div>
            <div className="asset-health-score-level">
              {renderStatusData(assetHealthStatusData)}
            </div>
          </div>
        </div>

        <div className="showcard-card-class">
          <div className="showcard-card-class-main-div">
            <AssetHealthComponent
              assetScore={assetScore}
              preventiveMaintenanceScore={scores?.preventiveMaintenceScore}
              tpvScore={scores?.tpvScore}
              incidentScore={scores?.incidentScore}
              maintenanceWorkRequestScore={scores?.maintenanceWorkRequestScore}
              showcardClassName="asset-health-showcard-div"
              childClassName="asset-health-showcard-child-div"
            />
          </div>
        </div>
      </div>
    </Card>
  );
}
